import { AxiosInstance } from 'axios';

import Interceptor from '@/classes/Interceptor';

export default function useInterceptors(axiosInstance: AxiosInstance, interceptors: Array<Interceptor>): AxiosInstance {
  interceptors.forEach((interceptor: Interceptor) => {
    if (interceptor) {
      if (interceptor.request || interceptor.requestError) {
        axiosInstance.interceptors.request.use(interceptor.request, interceptor.requestError);
      }

      if (interceptor.response || interceptor.responseError) {
        axiosInstance.interceptors.response.use(interceptor.response, interceptor.responseError);
      }
    }
  });

  return axiosInstance;
}
